import { ErrorOutlineOutlined } from '@material-ui/icons'
import { useEffect, useMemo } from 'react'
import { matchPath, Navigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'

import Loading from '@/components/loading'
import { useAuth } from '@/hooks/use-auth'
import { useCompanies } from '@/hooks/use-companies'
import { routes } from '@/routes/config'

import { ErrorComponent } from './error-component'

const pathOfRoutes = Object.values(routes).map((route) => route())

export function NotFoundRoute() {
  const location = useLocation()
  const { isAuthenticated, isLoading } = useAuth()
  const { isCompaniesLoading, isCompaniesError } = useCompanies()

  const isValidRoute = useMemo(
    () => pathOfRoutes.find((path) => matchPath({ path }, location.pathname)),
    [location.pathname],
  )

  useEffect(() => {
    if (!isCompaniesError) return

    const toastId = toast.error(<ErrorComponent />, {
      autoClose: false,
      icon: <ErrorOutlineOutlined />,
      closeButton: false,
    })

    return () => toast.dismiss(toastId)
  }, [isCompaniesError])

  if (!isValidRoute || (!isAuthenticated && !isLoading))
    return <Navigate to={routes.Login()} replace />

  if (isCompaniesError) return null

  if (isAuthenticated && !isCompaniesLoading)
    return <Navigate to={routes.Diagnoses()} replace />

  return <Loading />
}
